import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout"
)({
    component: () => <ToLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.tracking.to.title"),
    }),
});

function ToLayout() {
    return <Outlet />;
}
